import { render, staticRenderFns } from "./form6.vue?vue&type=template&id=65051af0&scoped=true&"
import script from "./form6.vue?vue&type=script&lang=js&"
export * from "./form6.vue?vue&type=script&lang=js&"
import style0 from "./form6.vue?vue&type=style&index=0&id=65051af0&scoped=true&lang=css&"
import style1 from "./form6.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65051af0",
  null
  
)

export default component.exports